import React,{useState,useContext,useEffect} from 'react'
import { AuthContextUser } from "../context/UserContext";
import axios from 'axios';

export const DasheboardCard = () => {

    const { currentUser } = useContext(AuthContextUser);

  return (
   <>
      <section class="m-0 content" dir='rtl'>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-xl-3">
                    <div class="data-box-container d-flex align-items-center b-24">
                        <a href="#" class="data-box-icon">
                            <img src="../icons/Ticket-primary.svg" alt="" />
                        </a>
                        <div class="d-flex flex-column">
                            <h3 class="h6">تیکت های شما</h3>
                            <span><a href="#">0</a>تیکت خوانده نشده دارید</span>
                        </div>
                        <a href="#" class="data-box-more">
                            <img src="../icons/arrow-left.svg" alt="" />
                        </a>
                    </div>
                </div>
                <div class="col-sm-12 col-xl-3 col-md-6">
                    <div class="data-box-container d-flex align-items-center b-24">
                        <a href="#" class="data-box-icon">
                            <img src="../img/quote.png" alt="" />
                        </a>
                        <div class="d-flex flex-column">
                            <h3 class="h6">تغییر رمز عبور</h3>
                            <span><a href="#"></a>انجام تغییر رمز</span>
                              </div>
                        <a href="#" class="data-box-more">
                            <img src="../icons/arrow-left.svg" alt="" />
                        </a>
                    </div>
                </div>
            </div>
        </section>
   </>
  )
}
